export enum SegmentName {
  // location
  EDIT_LOCATION = 'click_on_edit_locations',

  // event
  CREATE_EVENT = 'click_on_create_event',
  CREATE_EVENT_SAVE = 'click_on_create_event_save',
  CREATE_TIMESLOT = 'click_on_create_timeslot',
  EDIT_SINGLE_EVENT = 'click_on_edit_single_event',
  EDIT_SINGLE_EVENT_SAVE = 'click_on_edit_single_event_save',
  EDIT_EVENT_GROUP = 'click_on_edit_event_group',
  EDIT_EVENT_GROUP_SAVE = 'click_on_edit_event_group_save',

  // event groups
  CREATE_EVENT_FROM_EVENT_GROUPS_PAGE = 'trigger_create_event_from_event_groups_page',
  EVENT_GROUPS_TAB = 'trigger_event_groups_tab',
  EVENT_GROUPS_FILTER_OPEN = 'trigger_event_groups_filter_open',
  EVENT_GROUPS_FILTER_APPLY = 'trigger_event_groups_filter_apply',
  EVENT_GROUPS_FILTER_CLEAR = 'trigger_event_groups_filter_clear',

  CHECKIN_FILTER_LOCATION_APPLY = 'trigger_checkin_filter_location_apply',
  CHECKIN_FILTER_EVENT_APPLY = 'trigger_checkin_filter_event_apply',
  CHECKIN_FILTER_DATE_APPLY = 'trigger_checkin_filter_date_apply',
  CHECKIN_FILTER_SEARCH_APPLY = 'trigger_checkin_filter_search_apply',

  // products
  EVENT_TICKET_CREATED = 'event_ticket_created',
  EVENT_TICKET_UPDATED = 'event_ticket_updated',
  EVENT_TICKET_CREATE_ERROR = 'event_ticket_create_error',
  EVENT_TICKET_UPDATE_ERROR = 'event_ticket_update_error',
  EVENT_TICKET_GENERAL_ERROR = 'event_ticket_general_error',

  // calendar
  CREATE_EVENT_FROM_CALENDAR_PAGE = 'trigger_create_event_from_calendar_page',
  CALENDAR_NEXT = 'click_on_calendar_future',
  CALENDAR_PREV = 'click_on_calendar_past',

  // search
  SEARCH_API_CALLED = 'search_api_called',
  SEARCH_API_ERRORED = 'search_api_errored',

  // checklist
  CHECKLIST_CALLED = 'checklist_called',
  CHECKLIST_ERRORED = 'checklist_errored',

  // partner portal checklist
  PARTNER_PORTAL_CHECKLIST_PROFILE_UPDATED = 'partner_portal_checklist_profile_updated',
  PARTNER_PORTAL_CHECKLIST_EVENT_EDITED = 'partner_portal_checklist_event_edited',
  PARTNER_PORTAL_CHECKLIST_STUDIO_DATA_EDITED = 'partner_portal_checklist_studio_data_edited',
  PARTNER_PORTAL_CHECKLIST_STAFF_EDITED = 'partner_portal_checklist_staff_edited',

  // created partner portal checklist
  CREATED_PARTNER_PORTAL_CHECKLIST_STUDIO_UPDATED = 'created_partner_portal_checklist_studio_updated',
  CREATED_PARTNER_PORTAL_CHECKLIST_EVENT_CREATED = 'created_partner_portal_checklist_event_created',
  CREATED_PARTNER_PORTAL_CHECKLIST_REQUEST_APPROVAL = 'created_partner_portal_checklist_request_approval',
}

export const SegmentPageName = {
  '/provider/:domain/attendance': 'attendance', // ATTENDANCE
  '/provider/:domain/calendar': 'calendar', // CALENDAR
  '/provider/:domain': 'dashboard', // DASHBOARD
  '/provider/:domain/event/create': 'event_create', // EVENT_CREATE
  '/provider/:domain/event/create/Class': 'event_create_class', // EVENT_CREATE_CLASS
  '/provider/:domain/event/create/FreeTraining': 'event_create_free_training', // EVENT_CREATE_FREE_TRAINING
  '/provider/:domain/event/details/Class/:id': 'event_details_class', // EVENT_DETAILS_CLASS
  '/provider/:domain/event/details/FreeTraining/:id': 'event_details_free_training', // EVENT_DETAILS_FREE_TRAINING
  '/provider/:domain/event/edit/Class/:id': 'event_edit_occurrence_class', // EVENT_EDIT_OCCURENCE_CLASS
  '/provider/:domain/event/edit/:FreeTraining/:id': 'event_edit_occurrence_free_training', // EVENT_EDIT_OCCURENCE_FREE_TRAINING
  '/provider/:domain/eventgroups': 'eventgroups', // EVENTGROUPS
  '/provider/:domain/integrations': 'integrations', // INTEGRATIONS
  '/provider/:domain/payouts': 'payouts', // PAYOUTS
} as any;

export enum SegmentTrackName {
  MANUAL_BOOKING_SUBMIT = 'manual_booking_submit',
  MANUAL_BOOKING_SELECTED = 'manual_booking_selected',
  MANUAL_BOOKING_CLICKED = 'manual_booking_clicked',
}
